import {Breakpoint} from "../types/Breakpoint";
import {breakpoints} from "../constants/breakpoints";

export const isMediaMatch = (media: string) => {
  const query = `(min-width: ${media})`;
  return window.matchMedia(query).matches;
};

export const findClosestBreakpoint = () => {
  const queries = Object.values(breakpoints);
  let breakpoint: Breakpoint | undefined;
  for (let i = queries.length - 1; i >= 0; i--) {
    if (isMediaMatch(queries[i])) {
      breakpoint = (Object.keys(breakpoints) as Array<Breakpoint>)
        .find(key => breakpoints[key] === queries[i]);
      break;
    }
  }
  return breakpoint ?? "sm";
};
